module.exports = __webpack_public_path__ + "media/how_fastweb_works/become_cta-95c998b1.png";